import { render, staticRenderFns } from "./clipboardPhotoUploaderConfirm.vue?vue&type=template&id=0ad68e74&scoped=true&"
import script from "./clipboardPhotoUploaderConfirm.vue?vue&type=script&lang=babel&"
export * from "./clipboardPhotoUploaderConfirm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad68e74",
  null
  
)

export default component.exports